import { EStatusMatches } from '@/app/pages/sports/football/enums';
import { ScreenService } from '@/app/services/media-screen/screen.service';
import { TranslationService } from '@/app/services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@environments/environment';

interface ITeam {
  id: string;
  name: string;
  logo: string;
  score: number;
  halfScore: number | null;
  penaltyScore: number | null;
  nameTranslation: Record<string, string> | null;
  tsExternalId: string;
}

@Component({
  selector: 'app-home-team',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home-team.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTeamComponent {
  private translateService = inject(TranslationService);
  screenService = inject(ScreenService);

  homeTeam = input<ITeam>();
  matchStatus = input.required<string>();
  isWin = input.required<boolean>();
  countryName = input.required<string | null>();

  getLogoImg(): string {
    const defaultImg = environment.urlIMG + 'default.png';

    return this.homeTeam()?.logo || defaultImg;
  }

  getUrlTeam() {
    return this.translateService.getTraslateUrlTeamDetails(
      {
        en: this.homeTeam()?.nameTranslation?.['en'],
        es: this.homeTeam()?.nameTranslation?.['es'],
      },
      this.homeTeam()?.name ?? '',
      this.homeTeam()?.id ?? ''
    );
  }

  isLiveMatch(): boolean {
    return this.matchStatus() === EStatusMatches.NORMAL;
  }

  getTraduccionName(): string {
    const lang = this.translateService.getLangLocalStorage();
    const translation = this.homeTeam()?.nameTranslation?.[lang];
    return translation?.trim() ? translation : this.homeTeam()?.name!;
  }
}
